import type { EntityConfig } from '../types'

export const teamMemberEntity: EntityConfig = {
  id: 'team-member',
  displayName: 'Team Member',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'pending_invite', label: 'Pending invite' },
      { value: 'deactivated', label: 'Deactivated' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'pending_invite', label: 'Pending invite', color: 'pending' },
      { value: 'deactivated', label: 'Deactivated', color: 'neutral' },
    ],
    mappings: {
      all: ['active', 'pending_invite', 'deactivated'],
      active: ['active'],
      pending_invite: ['pending_invite'],
      deactivated: ['deactivated'],
    },
  },
  queryFields: {},
  uiFilterFields: ['search', 'status', 'role', 'dateRange'],
}
